module.exports = __webpack_public_path__ + "img/Wp_2089.83a4f16d.png";